// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3gryA","content":"LayoutSettings_content__2mvWC"};